import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'


export interface State {
  show: boolean,
  messages: string[],
  time?:number,
  color?:string
}

const defaultState: State = {
  show: false,
  messages: ['Все прошло успешно'],
  time:4000,
  color:'info'
};

const getters = {
  time: (state: State) => state.time,
  show: (state: State) => state.show,
  color: (state: State) => state.color,
  messages: (state: State) => state.messages
}

const mutations: MutationTree<State> = {
  setAlert(state:State,payload:State){
    state.show = payload.show
    state.messages = payload.messages
    if(payload.time) state.time = payload.time
    if(payload.color) state.color = payload.color

    setTimeout(()=>{
      state.show = false
      state.messages =[]
      state.color='info'
    },state.time)
  },
  setShow(state: State, payload: boolean) {
    state.show = payload


  },
  setMassages(state: State, payload: string) {
    state.messages.push(payload)
  },
  setColor(state: State, payload: string) {
    state.messages.push(payload)
  },
  clear(state:State){
    state.show =false
    state.messages =[]
    state.color='info'
  }
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations
}
